// @generated by protobuf-ts 2.9.4 with parameter optimize_code_size,long_type_number,generate_dependencies
// @generated from protobuf file "Protos/bookmarks.proto" (package "wuxiaworld.api.v2", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../google/protobuf/timestamp";
import { ChapterItem } from "./chapters";
import { BoolValue } from "../google/protobuf/wrappers";
import { PageInfoResponse } from "./pagination";
import { NovelItem } from "./novels";
import { PageInfoRequest } from "./pagination";
/**
 * @generated from protobuf message wuxiaworld.api.v2.GetBookmarksRequest
 */
export interface GetBookmarksRequest {
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.ReadingListType listType = 1;
     */
    listType: ReadingListType;
    /**
     * @generated from protobuf oneof: selector
     */
    selector: {
        oneofKind: "novelId";
        /**
         * @generated from protobuf field: int32 novelId = 2;
         */
        novelId: number;
    } | {
        oneofKind: "novelSlug";
        /**
         * @generated from protobuf field: string novelSlug = 3;
         */
        novelSlug: string;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: pagination
     */
    pagination: {
        oneofKind: "pageInfo";
        /**
         * @generated from protobuf field: wuxiaworld.api.v2.PageInfoRequest pageInfo = 4;
         */
        pageInfo: PageInfoRequest;
    } | {
        oneofKind: "cursor";
        /**
         * @generated from protobuf field: wuxiaworld.api.v2.GetBookmarksRequest.CursorRequest cursor = 5;
         */
        cursor: GetBookmarksRequest_CursorRequest;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.GetBookmarksRequest.SortBy sortBy = 6;
     */
    sortBy: GetBookmarksRequest_SortBy;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.GetBookmarksRequest.SortDirection sortDirection = 7;
     */
    sortDirection: GetBookmarksRequest_SortDirection;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.GetBookmarksRequest.CursorRequest
 */
export interface GetBookmarksRequest_CursorRequest {
    /**
     * @generated from protobuf field: int32 chapterOffset = 1;
     */
    chapterOffset: number;
    /**
     * @generated from protobuf field: int32 count = 2;
     */
    count: number;
}
/**
 * @generated from protobuf enum wuxiaworld.api.v2.GetBookmarksRequest.SortBy
 */
export enum GetBookmarksRequest_SortBy {
    /**
     * @generated from protobuf enum value: None = 0;
     */
    None = 0,
    /**
     * @generated from protobuf enum value: Name = 1;
     */
    Name = 1,
    /**
     * @generated from protobuf enum value: LastRead = 2;
     */
    LastRead = 2,
    /**
     * @generated from protobuf enum value: LatestRelease = 3;
     */
    LatestRelease = 3
}
/**
 * @generated from protobuf enum wuxiaworld.api.v2.GetBookmarksRequest.SortDirection
 */
export enum GetBookmarksRequest_SortDirection {
    /**
     * @generated from protobuf enum value: ASC = 0;
     */
    ASC = 0,
    /**
     * @generated from protobuf enum value: DESC = 1;
     */
    DESC = 1
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.GetBookmarksResponse
 */
export interface GetBookmarksResponse {
    /**
     * @generated from protobuf field: repeated wuxiaworld.api.v2.BookmarkItem items = 1;
     */
    items: BookmarkItem[];
    /**
     * @generated from protobuf field: repeated wuxiaworld.api.v2.NovelItem novels = 2;
     */
    novels: NovelItem[];
    /**
     * @generated from protobuf oneof: pagination
     */
    pagination: {
        oneofKind: "pageInfo";
        /**
         * @generated from protobuf field: wuxiaworld.api.v2.PageInfoResponse pageInfo = 3;
         */
        pageInfo: PageInfoResponse;
    } | {
        oneofKind: "cursor";
        /**
         * @generated from protobuf field: wuxiaworld.api.v2.GetBookmarksResponse.CursorResponse cursor = 4;
         */
        cursor: GetBookmarksResponse_CursorResponse;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.GetBookmarksResponse.CursorResponse
 */
export interface GetBookmarksResponse_CursorResponse {
    /**
     * @generated from protobuf field: int32 chapterOffset = 1;
     */
    chapterOffset: number;
    /**
     * @generated from protobuf field: int32 total = 2;
     */
    total: number;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.AddBookmarkRequest
 */
export interface AddBookmarkRequest {
    /**
     * @generated from protobuf field: int32 chapterId = 1;
     */
    chapterId: number;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.ReadingListType listType = 2;
     */
    listType: ReadingListType;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.AddBookmarkRequest.ReverseAction reverseAction = 3;
     */
    reverseAction: AddBookmarkRequest_ReverseAction;
}
/**
 * @generated from protobuf enum wuxiaworld.api.v2.AddBookmarkRequest.ReverseAction
 */
export enum AddBookmarkRequest_ReverseAction {
    /**
     * @generated from protobuf enum value: Replace = 0;
     */
    Replace = 0,
    /**
     * @generated from protobuf enum value: Fail = 1;
     */
    Fail = 1
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.AddBookmarkResponse
 */
export interface AddBookmarkResponse {
    /**
     * @generated from protobuf field: bool result = 1;
     */
    result: boolean;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.BookmarkItem previousBookmark = 2;
     */
    previousBookmark?: BookmarkItem;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.BookmarkItem currentBookmark = 3;
     */
    currentBookmark?: BookmarkItem;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.SetBookmarkSettingsRequest
 */
export interface SetBookmarkSettingsRequest {
    /**
     * @generated from protobuf field: int32 novelId = 1;
     */
    novelId: number;
    /**
     * @generated from protobuf field: google.protobuf.BoolValue notificationsEnabled = 2;
     */
    notificationsEnabled?: BoolValue;
    /**
     * @generated from protobuf field: google.protobuf.BoolValue locked = 3;
     */
    locked?: BoolValue;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.SetBookmarkSettingsResponse
 */
export interface SetBookmarkSettingsResponse {
    /**
     * @generated from protobuf field: bool result = 1;
     */
    result: boolean;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.DeleteBookmarkRequest
 */
export interface DeleteBookmarkRequest {
    /**
     * @generated from protobuf oneof: id
     */
    id: {
        oneofKind: "novelId";
        /**
         * @generated from protobuf field: int32 novelId = 1;
         */
        novelId: number;
    } | {
        oneofKind: "chapterId";
        /**
         * @generated from protobuf field: int32 chapterId = 2;
         */
        chapterId: number;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.ReadingListType listType = 3;
     */
    listType: ReadingListType;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.DeleteBookmarkResponse
 */
export interface DeleteBookmarkResponse {
    /**
     * @generated from protobuf field: bool result = 1;
     */
    result: boolean;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.GetBookmarkedNovelsRequest
 */
export interface GetBookmarkedNovelsRequest {
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.ReadingListType listType = 1;
     */
    listType: ReadingListType;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.PageInfoRequest pageInfo = 2;
     */
    pageInfo?: PageInfoRequest;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.GetBookmarkedNovelsResponse
 */
export interface GetBookmarkedNovelsResponse {
    /**
     * @generated from protobuf field: repeated wuxiaworld.api.v2.NovelItem items = 1;
     */
    items: NovelItem[];
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.PageInfoResponse pageInfo = 2;
     */
    pageInfo?: PageInfoResponse;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.BookmarkItem
 */
export interface BookmarkItem {
    /**
     * @generated from protobuf field: int32 novelId = 1;
     */
    novelId: number;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.ChapterItem chapter = 2;
     */
    chapter?: ChapterItem;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp readAt = 3;
     */
    readAt?: Timestamp;
    /**
     * @generated from protobuf field: bool locked = 4;
     */
    locked: boolean;
    /**
     * @generated from protobuf field: bool notificationsEnabled = 5;
     */
    notificationsEnabled: boolean;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.ChapterItem latestChapter = 6;
     */
    latestChapter?: ChapterItem;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.ReadingListType listType = 7;
     */
    listType: ReadingListType;
}
/**
 * @generated from protobuf enum wuxiaworld.api.v2.ReadingListType
 */
export enum ReadingListType {
    /**
     * @generated from protobuf enum value: Current = 0;
     */
    Current = 0,
    /**
     * @generated from protobuf enum value: Completed = 1;
     */
    Completed = 1,
    /**
     * @generated from protobuf enum value: Dropped = 3;
     */
    Dropped = 3,
    /**
     * @generated from protobuf enum value: OnHold = 4;
     */
    OnHold = 4,
    /**
     * @generated from protobuf enum value: Manual = 5;
     */
    Manual = 5
}
// @generated message type with reflection information, may provide speed optimized methods
class GetBookmarksRequest$Type extends MessageType<GetBookmarksRequest> {
    constructor() {
        super("wuxiaworld.api.v2.GetBookmarksRequest", [
            { no: 1, name: "listType", kind: "enum", T: () => ["wuxiaworld.api.v2.ReadingListType", ReadingListType] },
            { no: 2, name: "novelId", kind: "scalar", oneof: "selector", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "novelSlug", kind: "scalar", oneof: "selector", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "pageInfo", kind: "message", oneof: "pagination", T: () => PageInfoRequest },
            { no: 5, name: "cursor", kind: "message", oneof: "pagination", T: () => GetBookmarksRequest_CursorRequest },
            { no: 6, name: "sortBy", kind: "enum", T: () => ["wuxiaworld.api.v2.GetBookmarksRequest.SortBy", GetBookmarksRequest_SortBy] },
            { no: 7, name: "sortDirection", kind: "enum", T: () => ["wuxiaworld.api.v2.GetBookmarksRequest.SortDirection", GetBookmarksRequest_SortDirection] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.GetBookmarksRequest
 */
export const GetBookmarksRequest = new GetBookmarksRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBookmarksRequest_CursorRequest$Type extends MessageType<GetBookmarksRequest_CursorRequest> {
    constructor() {
        super("wuxiaworld.api.v2.GetBookmarksRequest.CursorRequest", [
            { no: 1, name: "chapterOffset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "wuxiaworld.api.v2.range": { max: { value: 100 } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.GetBookmarksRequest.CursorRequest
 */
export const GetBookmarksRequest_CursorRequest = new GetBookmarksRequest_CursorRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBookmarksResponse$Type extends MessageType<GetBookmarksResponse> {
    constructor() {
        super("wuxiaworld.api.v2.GetBookmarksResponse", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BookmarkItem },
            { no: 2, name: "novels", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => NovelItem },
            { no: 3, name: "pageInfo", kind: "message", oneof: "pagination", T: () => PageInfoResponse },
            { no: 4, name: "cursor", kind: "message", oneof: "pagination", T: () => GetBookmarksResponse_CursorResponse }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.GetBookmarksResponse
 */
export const GetBookmarksResponse = new GetBookmarksResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBookmarksResponse_CursorResponse$Type extends MessageType<GetBookmarksResponse_CursorResponse> {
    constructor() {
        super("wuxiaworld.api.v2.GetBookmarksResponse.CursorResponse", [
            { no: 1, name: "chapterOffset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "total", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.GetBookmarksResponse.CursorResponse
 */
export const GetBookmarksResponse_CursorResponse = new GetBookmarksResponse_CursorResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddBookmarkRequest$Type extends MessageType<AddBookmarkRequest> {
    constructor() {
        super("wuxiaworld.api.v2.AddBookmarkRequest", [
            { no: 1, name: "chapterId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "listType", kind: "enum", T: () => ["wuxiaworld.api.v2.ReadingListType", ReadingListType] },
            { no: 3, name: "reverseAction", kind: "enum", T: () => ["wuxiaworld.api.v2.AddBookmarkRequest.ReverseAction", AddBookmarkRequest_ReverseAction] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.AddBookmarkRequest
 */
export const AddBookmarkRequest = new AddBookmarkRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddBookmarkResponse$Type extends MessageType<AddBookmarkResponse> {
    constructor() {
        super("wuxiaworld.api.v2.AddBookmarkResponse", [
            { no: 1, name: "result", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "previousBookmark", kind: "message", T: () => BookmarkItem },
            { no: 3, name: "currentBookmark", kind: "message", T: () => BookmarkItem }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.AddBookmarkResponse
 */
export const AddBookmarkResponse = new AddBookmarkResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBookmarkSettingsRequest$Type extends MessageType<SetBookmarkSettingsRequest> {
    constructor() {
        super("wuxiaworld.api.v2.SetBookmarkSettingsRequest", [
            { no: 1, name: "novelId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "notificationsEnabled", kind: "message", T: () => BoolValue },
            { no: 3, name: "locked", kind: "message", T: () => BoolValue }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.SetBookmarkSettingsRequest
 */
export const SetBookmarkSettingsRequest = new SetBookmarkSettingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBookmarkSettingsResponse$Type extends MessageType<SetBookmarkSettingsResponse> {
    constructor() {
        super("wuxiaworld.api.v2.SetBookmarkSettingsResponse", [
            { no: 1, name: "result", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.SetBookmarkSettingsResponse
 */
export const SetBookmarkSettingsResponse = new SetBookmarkSettingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteBookmarkRequest$Type extends MessageType<DeleteBookmarkRequest> {
    constructor() {
        super("wuxiaworld.api.v2.DeleteBookmarkRequest", [
            { no: 1, name: "novelId", kind: "scalar", oneof: "id", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "chapterId", kind: "scalar", oneof: "id", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "listType", kind: "enum", T: () => ["wuxiaworld.api.v2.ReadingListType", ReadingListType] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.DeleteBookmarkRequest
 */
export const DeleteBookmarkRequest = new DeleteBookmarkRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteBookmarkResponse$Type extends MessageType<DeleteBookmarkResponse> {
    constructor() {
        super("wuxiaworld.api.v2.DeleteBookmarkResponse", [
            { no: 1, name: "result", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.DeleteBookmarkResponse
 */
export const DeleteBookmarkResponse = new DeleteBookmarkResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBookmarkedNovelsRequest$Type extends MessageType<GetBookmarkedNovelsRequest> {
    constructor() {
        super("wuxiaworld.api.v2.GetBookmarkedNovelsRequest", [
            { no: 1, name: "listType", kind: "enum", T: () => ["wuxiaworld.api.v2.ReadingListType", ReadingListType] },
            { no: 2, name: "pageInfo", kind: "message", T: () => PageInfoRequest }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.GetBookmarkedNovelsRequest
 */
export const GetBookmarkedNovelsRequest = new GetBookmarkedNovelsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBookmarkedNovelsResponse$Type extends MessageType<GetBookmarkedNovelsResponse> {
    constructor() {
        super("wuxiaworld.api.v2.GetBookmarkedNovelsResponse", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => NovelItem },
            { no: 2, name: "pageInfo", kind: "message", T: () => PageInfoResponse }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.GetBookmarkedNovelsResponse
 */
export const GetBookmarkedNovelsResponse = new GetBookmarkedNovelsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BookmarkItem$Type extends MessageType<BookmarkItem> {
    constructor() {
        super("wuxiaworld.api.v2.BookmarkItem", [
            { no: 1, name: "novelId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "chapter", kind: "message", T: () => ChapterItem },
            { no: 3, name: "readAt", kind: "message", T: () => Timestamp },
            { no: 4, name: "locked", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "notificationsEnabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "latestChapter", kind: "message", T: () => ChapterItem },
            { no: 7, name: "listType", kind: "enum", T: () => ["wuxiaworld.api.v2.ReadingListType", ReadingListType] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.BookmarkItem
 */
export const BookmarkItem = new BookmarkItem$Type();
/**
 * @generated ServiceType for protobuf service wuxiaworld.api.v2.Bookmarks
 */
export const Bookmarks = new ServiceType("wuxiaworld.api.v2.Bookmarks", [
    { name: "GetBookmarks", options: {}, I: GetBookmarksRequest, O: GetBookmarksResponse },
    { name: "GetBookmarkedNovels", options: {}, I: GetBookmarkedNovelsRequest, O: GetBookmarkedNovelsResponse },
    { name: "AddBookmark", options: {}, I: AddBookmarkRequest, O: AddBookmarkResponse },
    { name: "SetBookmarkSettings", options: {}, I: SetBookmarkSettingsRequest, O: SetBookmarkSettingsResponse },
    { name: "DeleteBookmark", options: {}, I: DeleteBookmarkRequest, O: DeleteBookmarkResponse }
]);
